





























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { PayServiceModel } from '@/models/payservice';

@Component
export default class AmountDetailPayService extends Vue {
    @Prop({ default: () => new PayServiceModel() })
    private payservice!: PayServiceModel;
}
